<template>
  <div class="d-book-user-review-social">
    <div class="grid-flex grid-middle grid-no-response">
      <div class="grid-item">
        <button
          class="upvote-button button-sm button-follow"
          :class="{ 'button-yellow': userReview.is_upvoted }"
          :disabled="isProcessing"
          title="Like"
          @click="upvote"
        >
          <DuiIconLike
            v-if="userReview.is_upvoted"
            class="icon-white"
          />

          <DuiIconLikeStroke v-else />

          <span class="num-upvotes valign-middle">{{ userReview.upvotes }}</span>
        </button>

        <a
          v-if="!!userReview.upvotes"
          class="view-upvotes valign-middle"
          @click="showUpvotes"
        >View likes</a>
      </div>

      <div class="grid-item-shrink">
        <DuiLoadingIndicator
          v-if="isLoadingCommentsCount"
          size="sm"
        />
        <span v-else>
          <DuiIconBalloonStroke />
          <span class="num-comments valign-middle">{{ numComments }}</span>
        </span>
      </div>
    </div>

    <DUpvotesModal
      v-if="isUpvotesDisplayed"
      item-type="user-review"
      :item-slug="userReview.slug"
      :is-user-signed-in="isUserSignedIn"
      @dismiss="dismissUpvotes"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import commentsService from '@d-services/comments-service/comments-service';
import DUpvotesModal from '@d-components/modals/d-upvotes-modal/d-upvotes-modal.vue';
import { getErrorMessage } from '@d-shared/utils/errors';
import userReviewsService from '@d-services/user-reviews-service/user-reviews-service';

export default {
  components: {
    DUpvotesModal,
  },
  props: {
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
    userReview: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoadingCommentsCount: false,
    isProcessing: false,
    isUpvotesDisplayed: false,
    numComments: 0,
  }),
  mounted() {
    this.loadCommentsCount();
  },
  methods: {
    async loadCommentsCount() {
      this.$set(this, 'isLoadingCommentsCount', true);

      try {
        const numComments = await commentsService.getUserReviewCommentsCount(this.userReview.slug);
        this.$set(this, 'numComments', numComments);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isLoadingCommentsCount', false);
    },

    // Upvote
    async addUpvote() {
      this.$set(this, 'isProcessing', true);

      try {
        await userReviewsService.addUserReviewUpvote(this.userReview.slug);
        this.$set(this.userReview, 'is_upvoted', true);
        this.$set(this.userReview, 'upvotes', this.userReview.upvotes + 1);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isProcessing', false);
    },

    async removeUpvote() {
      this.$set(this, 'isProcessing', true);

      try {
        await userReviewsService.removeUserReviewUpvote(this.userReview.slug);
        this.$set(this.userReview, 'is_upvoted', false);
        this.$set(this.userReview, 'upvotes', this.userReview.upvotes - 1);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isProcessing', false);
    },

    upvote() {
      if (!this.isUserSignedIn) {
        Vue.prototype.signupModal.show();
        return;
      }

      if (this.userReview.is_upvoted) {
        this.removeUpvote();
        return;
      }

      this.addUpvote();
    },
    // END Upvote

    // Upvotes
    dismissUpvotes() {
      this.$set(this, 'isUpvotesDisplayed', false);
    },

    showUpvotes() {
      if (!this.isUserSignedIn) {
        Vue.prototype.signupModal.show();
        return;
      }

      this.$set(this, 'isUpvotesDisplayed', true);
    },
    // END Upvotes
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-book-user-review-social {
  .upvote-button {
    margin-right: $_0-5em;
  }
}
</style>
